const getDependencies = (rootState) => rootState.ws.template.meta.dependencies;

export default getDependencies;
